import axios from "axios";
import { useAuthStore } from "@/stores/auth";
import router from "@/router"; // Importa el router para redirigir al login
import { useLoading } from "@/composables/useLoading";

const { startLoading, stopLoading } = useLoading();

const apiClient = axios.create({
  // baseURL: process.env.VUE_APP_API_URL,
  // baseURL: "http://localhost/mily-backend/api/endpoints/",
  baseURL: "https://milyssalonybarberaz.com/mily-backend/api/endpoints/",
  headers: {
    "Content-Type": "application/json",
  },
});


// Interceptor para añadir el token a cada petición
apiClient.interceptors.request.use((config) => {
  startLoading();
  const authStore = useAuthStore();
  if (authStore.token) {
    // Decodificar el token para verificar la expiración
    const tokenPayload = JSON.parse(atob(authStore.token.split(".")[1])); // Decodifica el payload del JWT
    const currentTime = Math.floor(Date.now() / 1000); // Tiempo actual en segundos

    if (tokenPayload.exp && tokenPayload.exp < currentTime) {
      // Si el token ha expirado, redirigir al login
      authStore.logout(); // Limpia el estado de autenticación
      router.push("/login"); // Redirige al login
      // return Promise.reject(new Error("Token expirado"));
    }

    // Añadir el token al encabezado
    config.headers.Authorization = `Bearer ${authStore.token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => {
    stopLoading();
    return response;
  },
  (error) => {
    stopLoading();
    return Promise.reject(error);
  }
);

export default apiClient;
